<!-- Filtrado de boletas disponibles desde API -->
<template>
    <div v-if="loadSkeleton" class="ma-3">
        <SkeletonLoader tipo="table-heading, card" ruta="haberes" />
    </div>
    <div v-else class="justify-center align-center ma-3">
        <v-card flat>
            <v-card-title class="text-h5 font-weight-bold ">
                <v-icon color="primary" class="mr-2" size="34">mdi-list-box-outline</v-icon>
                Recibos de haberes
            </v-card-title>
        </v-card>
        <v-alert colored-border elevation="0" class="font-weight-regular rounded-0" dense border="left"
            color="orange darken-3">
            <div class="font-weight-bold orange--text text--darken-3">
                IMPORTANTE:
            </div>
            La correcta impresión de los recibos de haberes dependerá de la configuración de cada PC,
            impresora y calidad de su tinta o tóner.
        </v-alert>
        <v-card class="rounded-0" outlined>
            <v-card-text class="font-weight-bold primary--text text-h5">
                Descargá tus recibos de haberes
            </v-card-text>
            <FormReciboHaberes />
        </v-card>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import FormReciboHaberes from '@/components/forms/FormReciboHaberes.vue';
import SkeletonLoader from '@/components/alerts/SkeletonLoader.vue';

export default {
    components: {
        FormReciboHaberes,
        SkeletonLoader
    },
    data() {
        return {
        }
    },
    mounted() {
        //obtengo las haberes disponibles para imprimir
        this.getReciboHaberes({ nroafi: this.nroafi, token: this.token });
    },
    methods: {
        ...mapActions('haberes', ['getReciboHaberes']),
    },
    computed: {
        ...mapGetters('auth', ['isAuthenticated', 'loadSkeleton', 'nroafi', 'user', 'token']),
    }
};
</script>